import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";
import Hummingbird from "../images/corner/corner-hummingbird.webp";
import Logo from "../images/logo-dark.svg";
import Facebook from "../images/icons/facebook.svg";
import TikTok from "../images/icons/tiktok.svg";
import Instagram from "../images/icons/instagram.svg";
import YouTube from "../images/icons/youtube.svg";
import Map from "../images/map.png";
import moment from "moment";

export default function Footer(props) {
  return (
    <footer className="footer">
      <img className="corner-image" src={Hummingbird} alt="" />
      <div className="container">
        <img
          className="width-200 p-t-20 logo"
          src={Logo}
          alt="auburn road logo"
        />
        <p>
          <a
            href="https://www.google.com/search?q=directions+to+117+Sharptown+Auburn+Road%2C+Pilesgrove%2C+NJ+08098&rlz=1C5CHFA_enUS941US941&oq=directions+to+117+Sharptown+Auburn+Road%2C+Pilesgrove%2C+NJ+08098&aqs=chrome..69i57.3750j0j7&sourceid=chrome&ie=UTF-8"
            target="_blank"
            rel="noreferrer noopener"
            className="i"
          >
            117 Sharptown Auburn Road, Pilesgrove, NJ 08098
          </a>
        </p>
        <div className="flex-1 d-flex social-links py-2">
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.facebook.com/AuburnRoad/"
          >
            <img src={Facebook} alt="facebook icon" />
          </a>
          <a
            className="link"
            rel="noreferrer noopener"
            href="https://www.tiktok.com/search?lang=en&q=auburn%20road%20vineyard&t=1773952806864"
            target="_blank"
          >
            <img src={TikTok} alt="tik tok icon" />
          </a>
          <a
            className="link"
            rel="noreferrer noopener"
            href="https://www.instagram.com/auburnroadvineyards/"
            target="_blank"
          >
            <img src={Instagram} alt="instagram icon" />
          </a>
          <a
            className="link"
            rel="noreferrer noopener"
            href="https://www.youtube.com/channel/UCjDWBe2tG2QgdACnturOheA"
            target="_blank"
          >
            <img src={YouTube} alt="youtube icon" />
          </a>
        </div>
      </div>
      <div className="container d-flex flex-column flex-md-row justify-content-baseline align-items-baseline p-b-50 p-md-b-0">
        <div className="flex-1 py-4">
            <h3 className="pb-2 subheading">learn more</h3>
          <div className="d-flex flex-column">
            <a
              className="link"
              href="https://auburnroadvineyards.orderport.net/wines/Available-Wines"
            >
              Our Wines
            </a>
            <Link className="link" to="/whats-happening" id="test-click">
              What's Happening
            </Link>
            <Link className="link" to="/faq">
              FAQ
            </Link>
            <Link className="link" to="/wine-stories">
              Wine Stories (blog)
            </Link>
          </div>
        </div>
        <div className="flex-1 py-4">
          <h3 className="pb-2 subheading">join us</h3>
          <div className="d-flex flex-column">
            <Link className="link" to="/menu">
              Menu
            </Link>
            <a
              className="link"
              href="https://auburnroadvineyards.orderport.net/wine-club"
            >
              CSA Wine Club
            </a>
            <Button
              className="link p-0 justify-content-start position-relative outgoing-link"
              href={`https://www.exploretock.com/auburnroadvineyards/search?date=${moment().format(
                "YYYY-MM-DD"
              )}&size=2`}
            >
              Reservations
            </Button>
            <Link className="link" to="/the-enoteca">
              The Enoteca Wine Bar
            </Link>
            <Link className="link" to="/giving-back-to-the-community">
              Auburn Road Gives Back
            </Link>
            <Link className="link" to="/private-events">
              Book your private event
            </Link>
          </div>
        </div>
        <div className="flex-1 py-4">
          <h3 className="pb-2 subheading">Sign up for our E-Newsletter</h3>
          <p>
            No cost, no commitment. Just a cool e-newsletter and a lot of great
            benefits!
          </p>
          <Button
            onClick={() =>
              (window.location.href =
                "https://auburnroadvineyards.orderport.net/newsletter")
            }
            className="button__secondary mt-3"
            small
          >
            sign up now
          </Button>
        </div>
      </div>
      <div className="container">
        <div className="flex-1 py-4">
          <img src={Map} className="width-200" alt="" />
        </div>
      </div>
      <div className="text-center p-b-10 w-75 m-auto">
        <span className="credit">
          copyright &copy; {moment().format("YYYY")} Auburn Road, LLC | site
          design & development by{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.alvarezbrandingcompany.com"
          >
            Alvarez Branding Co.
          </a>
        </span>
      </div>
    </footer>
  );
}
